export default {

	init() {
		console.log('video init...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	bindEvents() {
		// Lazyload autoplay videos
		let elems = document.querySelectorAll('video[data-autoplay], iframe[data-autoplay]');

		if (elems.length) {
			elems.forEach(function (elem) {
				Video.intersectObserver(elem);
			});
		}
	},

	intersectObserver(elem) {
		let observerOptions = {};
		let observer = new IntersectionObserver(function (entries) {
			for (var i = 0; i < entries.length; i++) {
				let entry = entries[i];
				if (entry.isIntersecting) {
					if (elem.nodeName.toLowerCase() === 'iframe') {
						// Vimeo embeds (will autoplay based on url params)
						let source = elem.dataset.src;
						elem.src = source;
						// Vimeo embeds to manually autoplay muted with unmute button
						if (elem.dataset.autoplay === 'muted') {
							Video.autoplayMuted(elem);
							observer.unobserve(elem);
						}
					} else {
						// Video elements
						for (const child of elem.children) {
							let source = child.dataset.src;
							child.src = source;
						}
						elem.setAttribute('autoplay', '');
						elem.load();
						observer.unobserve(elem);
					}
					break;
				}
			}
		}, observerOptions);

		observer.observe(elem);
	},

	autoplayMuted(elem) {
		let button = elem.parentElement.querySelector('button');
		let player = new Vimeo.Player(elem);

		player.setVolume(0);
		player.setLoop(1);
		player.play();

		if (!button) {
			return;
		}

		// Toggle custom mute button state
		button.addEventListener('click', function(e) {
			let btn = this;
			let active = btn.classList.contains('is-active');

			if (active) {
				player.setVolume(0);
				btn.classList.remove('is-active');
			} else {
				player.setVolume(1);
				btn.classList.add('is-active');
			}
		});
	}

};